import { shortUUID } from '../base/utils/id-generator'
import { IHistoryItem } from '../interfaces/history'
import api from './api'
import db from './db'

async function get(lastChanged: string) {
    const remoteHistory = await api.get('/api/history?last-changed=' + lastChanged)
    return remoteHistory
}

async function save(item: IHistoryItem) {
    db.save('history', item)
    push(item)
}

async function update(item: IHistoryItem) {
    item.last_changed = new Date().toISOString()
    item.synced = 0
    await db.update('history', item.id, item)
    push(item)
}

async function push(item: IHistoryItem) {
    try {
        await api.post('/api/history', item)
        await db.update('history', item.id, {...item, synced: 1})
    } catch (error) {
        console.log(error)
    }
}

export default {
    get,
    save,
    update,
    push
}